import React, { useCallback } from "react";
import ReusableModal from "../../../../components/Modals/ReusableModal";
import Select from "react-select";
import {
  useFetchPlannerZonesMutation,
  useUpsertZoneLocationsMutation,
} from "../../../../features/zones/zonesApiSlice";
import debounce from "lodash.debounce";
const CommunityZoneEditModal = ({
  open,
  setOpen,
  community,
  updateCommunityZones,
  communityZones = null,
}) => {
  const [zones, setZones] = React.useState([]);

  const [selectedZones, setSelectedZones] = React.useState(
    communityZones !== null
      ? communityZones.map((zone) => ({
          value: zone.id,
          label: zone.name,
        }))
      : community.zones.map((zone) => ({
          value: zone.id,
          label: zone.name,
        }))
  );

  const handleSelectedZones = (selectedZones) => {
    setSelectedZones(selectedZones);
  };

  const [fetchPlannerZones, { isLoading: zonesLoading }] =
    useFetchPlannerZonesMutation();

  const [upsertZoneLocations, { isLoading: upsertZoneLocationsLoading }] =
    useUpsertZoneLocationsMutation();

  const fetchZones = async (inputValue, initial = false) => {
    try {
      setZones([]);

      if (!inputValue && !initial) return;

      const { data } = await fetchPlannerZones({
        search: inputValue.trim(),
        providerIds: [],
        patientIds: [],
        zoneIds: [],
        take: 50,
      }).unwrap();

      const zones = data.map((data) => ({
        label: data.name,
        value: data.id,
      }));

      setZones(zones);
    } catch (error) {
      console.log("Error fetching locations:", error);
    }
  };

  const fetchZonesDebounced = useCallback(
    debounce((inputValue, initial = false) => fetchZones(inputValue, initial)),
    200
  );

  const handleSave = async () => {
    try {
      console.log({
        locationId: community.id,
        type: "COMMUNITY_HOME",
        zoneIds: selectedZones.map((zone) => zone.value),
      });

      await upsertZoneLocations({
        locationId: community.id,
        type: "COMMUNITY_HOME",
        zoneIds: selectedZones.map((zone) => zone.value),
      }).unwrap();

      updateCommunityZones(
        community.id,
        selectedZones.map((zone) => ({ id: zone.value, name: zone.label }))
      );

      setOpen(false);
    } catch (error) {
      console.log("Error updating patient zones:", error);
    }
  };

  React.useEffect(() => {
    setSelectedZones(
      communityZones !== null
        ? communityZones.map((zone) => ({
            value: zone.id,
            label: zone.name,
          }))
        : community.zones.map((zone) => ({
            value: zone.id,
            label: zone.name,
          }))
    );
  }, [community.zones, communityZones]);

  return (
    <ReusableModal
      open={open}
      title="Edit Zone"
      onClose={() => {
        setOpen(false);
      }}
    >
      <div className="flex flex-col gap-16 p-8 w-[600px]">
        <Select
          placeholder="Search by Zone..."
          isSearchable
          isClearable
          className="w-full overflow-visible h-9 z-[1000]"
          isMulti
          value={selectedZones}
          onChange={handleSelectedZones}
          options={zones}
          noOptionsMessage={() => "Search By Name..."}
          isLoading={zonesLoading}
          onMenuOpen={() => fetchZones("", true)}
          onInputChange={(inputValue, { action }) => {
            if (action === "input-change") {
              fetchZonesDebounced(inputValue);
            }
          }}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
        <button
          onClick={handleSave}
          className="w-full p-2 text-white rounded-md bg-primaryblue"
        >
          Save
        </button>
      </div>
    </ReusableModal>
  );
};

export default CommunityZoneEditModal;
